import ProductImagesCreate from "./productImagesCreate";
import ProductImagesEdit from "./productImagesEdit";
import ProductImagesList from "./productImagesList";

export default {
  // create: ProductImagesCreate,
  list: ProductImagesList,
  edit: ProductImagesEdit,
};
